const primarySkills = [
  { label: "JavaScript", value: "JavaScript" },
  { label: "React.js", value: "React.js" },
  { label: "Node.js", value: "Node.js" },
  { label: "Python", value: "Python" },
  { label: "Java", value: "Java" },
  { label: "HTML5", value: "HTML5" },
  { label: "CSS3", value: "CSS3" },
  { label: "SQL", value: "SQL" },
  { label: "Git", value: "Git" },
  { label: "Redux", value: "Redux" },
  { label: "Angular", value: "Angular" },
  { label: "Vue.js", value: "Vue.js" },
  { label: "Express.js", value: "Express.js" },
  { label: "MongoDB", value: "MongoDB" },
  { label: "RESTful APIs", value: "RESTful APIs" },
  { label: "Webpack", value: "Webpack" },
  { label: "Docker", value: "Docker" },
  { label: "Jenkins", value: "Jenkins" },
  { label: "GraphQL", value: "GraphQL" },
  { label: "TypeScript", value: "TypeScript" },
  { label: "Sass", value: "Sass" },
  { label: "Python Django", value: "Python Django" },
  { label: "Flask", value: "Flask" },
  { label: "PHP Laravel", value: "PHP Laravel" },
  { label: "Ruby on Rails", value: "Ruby on Rails" },
  { label: "C++", value: "C++" },
  { label: "C#", value: "C#" },
  { label: "ASP.NET", value: "ASP.NET" },
  { label: "Swift", value: "Swift" },
  { label: "Kotlin", value: "Kotlin" },
  { label: "AWS Lambda", value: "AWS Lambda" },
  { label: "Azure Functions", value: "Azure Functions" },
  { label: "Google Cloud Platform", value: "Google Cloud Platform" },
  { label: "GraphQL Apollo", value: "GraphQL Apollo" },
  { label: "NestJS", value: "NestJS" },
  { label: "PostgreSQL", value: "PostgreSQL" },
  { label: "MySQL", value: "MySQL" },
  { label: "Jest", value: "Jest" },
  { label: "Mocha", value: "Mocha" },
];

const secondarySkills = [
  { label: "UI/UX Design", value: "UI/UX Design" },
  { label: "Technical Writing", value: "Technical Writing" },
  { label: "Agile Methodologies", value: "Agile Methodologies" },
  { label: "Project Management", value: "Project Management" },
  { label: "Data Analysis", value: "Data Analysis" },
  { label: "Machine Learning", value: "Machine Learning" },
  { label: "Cybersecurity", value: "Cybersecurity" },
  { label: "DevOps Practices", value: "DevOps Practices" },
  { label: "Quality Assurance", value: "Quality Assurance" },
  { label: "Troubleshooting", value: "Troubleshooting" },
  { label: "Technical Support", value: "Technical Support" },
  { label: "Cloud Computing", value: "Cloud Computing" },
  { label: "Database Management", value: "Database Management" },
  { label: "Network Administration", value: "Network Administration" },
  { label: "Customer Service", value: "Customer Service" },
  { label: "Business Analysis", value: "Business Analysis" },
  { label: "Data Visualization", value: "Data Visualization" },
  { label: "Content Management", value: "Content Management" },
  { label: "Digital Marketing", value: "Digital Marketing" },
  { label: "Social Media Management", value: "Social Media Management" },
];

const spokenLanguages = [
  { label: "English", value: "English" },
  { label: "Spanish", value: "Spanish" },
  { label: "French", value: "French" },
  { label: "German", value: "German" },
  { label: "Mandarin Chinese", value: "Mandarin Chinese" },
  { label: "Hindi", value: "Hindi" },
  { label: "Arabic", value: "Arabic" },
  { label: "Russian", value: "Russian" },
  { label: "Portuguese", value: "Portuguese" },
  { label: "Japanese", value: "Japanese" },
  { label: "Korean", value: "Korean" },
  { label: "Italian", value: "Italian" },
  { label: "Dutch", value: "Dutch" },
  { label: "Swedish", value: "Swedish" },
  { label: "Turkish", value: "Turkish" },
  { label: "Indonesian", value: "Indonesian" },
  { label: "Farsi", value: "Farsi" },
  { label: "Swahili", value: "Swahili" },
  { label: "Vietnamese", value: "Vietnamese" },
  { label: "Urdu", value: "Urdu" },
  { label: "Bengali", value: "Bengali" },
  { label: "Thai", value: "Thai" },
  { label: "Filipino", value: "Filipino" },
  { label: "Malay", value: "Malay" },
  { label: "Hausa", value: "Hausa" },
  { label: "Yoruba", value: "Yoruba" },
  { label: "Sinhala", value: "Sinhala" },
  { label: "Burmese", value: "Burmese" },
  { label: "Khmer", value: "Khmer" },
  { label: "Tagalog", value: "Tagalog" },
  { label: "Hmong", value: "Hmong" },
  { label: "Swedish", value: "Swedish" },
  { label: "Norwegian", value: "Norwegian" },
  { label: "Danish", value: "Danish" },
  { label: "Finnish", value: "Finnish" },
  { label: "Czech", value: "Czech" },
  { label: "Polish", value: "Polish" },
  { label: "Hungarian", value: "Hungarian" },
  { label: "Greek", value: "Greek" },
  { label: "Hebrew", value: "Hebrew" },
];

const employmentType = [
  { label: "Full-time", value: "Full-time" },
  { label: "Part-time", value: "Part-time" },
  { label: "Contract", value: "Contract" },
  { label: "Internship", value: "Internship" },
  { label: "Freelance", value: "Freelance" },
  { label: "Self-employed", value: "Self-employed" },
  { label: "Apprenticeship", value: "Apprenticeship" },
  { label: "Seasonal", value: "Seasonal" },
];

const locationType = [
  { label: "Remote", value: "Remote" },
  { label: "On-site", value: "On-site" },
  { label: "Hybrid", value: "Hybrid" },
];

const qualifications = [
    { label: "Primary/Secondary School/'O' level", value: "Primary/Secondary School/'O' level" },
    { label: "Higher Secondary/Pre-U/'A' level", value: "Higher Secondary/Pre-U/'A' level" },
    { label: "Professional Certificate/NiTEC", value: "Professional Certificate/NiTEC" },
    { label: "Diploma", value: "Diploma" },
    { label: "Advanced/Higher/Graduate Diploma", value: "Advanced/Higher/Graduate Diploma" },
    { label: "Bachelor's Degree", value: "Bachelor's Degree" },
    { label: "Post Graduate Diploma", value: "Post Graduate Diploma" },
    { label: "Professional Degree", value: "Professional Degree" },
    { label: "Master's Degree", value: "Master's Degree" },
    { label: "Doctorate (PhD)", value: "Doctorate (PhD)" },
]

const visaStatus = [
    { label: "Citizen", value: "Citizen" },
    { label: "Permanent Resident", value: "Permanent Resident" },
    { label: "Work Visa", value: "Work Visa" },
    { label: "Student Visa", value: "Student Visa" },
    { label: "Dependent Visa", value: "Dependent Visa" },
    { label: "Sponsored/Sponsored Work Visa", value: "Sponsored/Sponsored Work Visa" },
    { label: "Temporary Protected Status (TPS)", value: "Temporary Protected Status (TPS)" },
  ];

export const Lists = {
  primarySkills,
  secondarySkills,
  spokenLanguages,
  employmentType,
  locationType,
  qualifications,
  visaStatus
};
